<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-col>
    <v-col>
      <v-row>
        <v-col cols="4">
          <v-menu
            ref="dateFromMenu"
            v-model="dateFromMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="params.start_date"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="params.start_date"
                label="Выбрать начальную дату"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="tmpDateFrom" locale="ru-ru" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="resetDateFrom"> Сбросить </v-btn>
              <v-btn text color="primary" @click="dateFromMenu = false">Отменить</v-btn>
              <v-btn text color="primary" @click="$refs.dateFromMenu.save(tmpDateFrom)"
                >Выбрать
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="4">
          <v-menu
            ref="dateToMenu"
            v-model="dateToMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="params.end_date"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="params.end_date"
                label="Выбрать конечную дату"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="tmpDateTo" locale="ru-ru" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="resetDateTo"> Сбросить </v-btn>
              <v-btn texttext color="primary" @click="dateToMenu = false">Отменить</v-btn>
              <v-btn text color="primary" @click="$refs.dateToMenu.save(tmpDateTo)">Выбрать </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="4">
          <v-rating
            v-model="params.priority"
            color="secondary"
            background-color="grey"
            clearable
            :loading="loading"
            length="4"
          ></v-rating>
        </v-col>
        <v-col cols="12">
          <v-row>
            <v-col cols="8">
              <v-text-field
                label="Поиск по ключевому слову"
                v-model="params.title_contains"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :indeterminate="true"
                    :loading="loading"
                    v-on="on"
                    :color="params.published ? 'secondary' : 'grey'"
                    v-model="params.published"
                    icon
                    @click="params.published = !params.published"
                  >
                    <v-icon>mdi-earth</v-icon>
                  </v-btn>
                </template>
                <span>{{ params.published ? 'Опубликованные' : 'Не опубликованные' }}</span>
              </v-tooltip>
              <!--                            <v-tooltip top v-if="$attrs.site_key !== ''">-->
              <!--                                <template v-slot:activator="{ on }">-->
              <!--                                    <v-btn-->
              <!--                                            v-on="on"-->
              <!--                                            :color="params.reviewed ? 'secondary' : 'grey' "-->
              <!--                                            :loading="loading"-->
              <!--                                            @click="params.reviewed = !params.reviewed" icon>-->
              <!--                                        <v-icon>mdi-eye</v-icon>-->
              <!--                                    </v-btn>-->
              <!--                                </template>-->
              <!--                                <span>{{params.reviewed ? 'Просмотренные' : 'Не просмотренные' }}</span>-->
              <!--                            </v-tooltip>-->
            </v-col>
            <v-col> </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>

    <v-col style="min-height: 10px">
      <v-progress-linear v-show="loading" color="primary" height="3" indeterminate absolute>
      </v-progress-linear>
    </v-col>

    <!--        Pagination-->
    <Paginator :total-page="totalPage" :page="params.page" @page-changed="changePage"></Paginator>
    <!--            Pagination end-->

    <v-row>
      <v-col v-for="article in articles" v-bind:key="article.id">
        <ArticleListItem :article="article" @updatedArticle="updateArticle"></ArticleListItem>
      </v-col>
    </v-row>

    <v-col lg6 v-show="totalPage === 0" class="text-lg-center">
      <h1>Пусто :(</h1>
    </v-col>

    <!--        Pagination-->
    <Paginator :total-page="totalPage" :page="params.page" @page-changed="changePage"></Paginator>
    <!--            Pagination end-->

    <v-btn
      dark
      absolute
      top
      right
      fab
      color="secondary"
      style="top: 30px"
      :to="{ name: 'article_create' }"
    >
      <v-icon dark>add</v-icon>
    </v-btn>
  </v-col>
</template>

<script>
import ArticleListItem from '@/components/ArticleListItem'
import apiMixin from '@/mixins/api'
import Paginator from '@/components/Paginator'

export default {
  name: 'ArticleList',
  components: { ArticleListItem, Paginator },
  mixins: [apiMixin],
  data() {
    return {
      loading: false,
      tmpDateFrom: '',
      tmpDateTo: '',
      dateFromMenu: false,
      dateToMenu: false,
      indeterminate_publish: null,
      articles: [],
      totalPage: 0,
      params: {
        title_contains: this.$route.query.title_contains || '',
        start_date: this.$route.query.start_date || '',
        end_date: this.$route.query.end_date || '',
        published: this.$route.query.published || true,
        reviewed: this.$route.query.reviewed || null,
        priority: this.$route.query.priority || null,
        page: 1,
        limit: 12,
      },
      countCancelToken: null,
      articlesCancelToken: null,
    }
  },
  watch: {
    params: {
      async handler(e) {
        this.$log.debug('params changed', this.$attrs.site_key)
        await this.$router.push({ query: e })
        this.updateData()
      },
      deep: true,
    },
    '$attrs.site_key'() {
      this.$log.debug('$attrs.site_key changed', this.$attrs.site_key, this.params.site_key)
      this.updateData()
    },
  },
  created() {
    this.$log.debug('before mount', this.$attrs.site_key)
    this.updateData()
  },
  mounted() {
    this.$log.debug('mounted', this.$attrs.site_key)
  },
  methods: {
    changePage(e) {
      this.params.page = e
    },
    resetDateFrom() {
      this.dateFromMenu = false
      this.$refs.dateFromMenu.save('')
      this.tmpDateFrom = ''
      this.params.start_date = ''
    },
    resetDateTo() {
      this.dateToMenu = false
      this.$refs.dateToMenu.save('')
      this.tmpDateFrom = ''
      this.params.end_date = ''
    },
    updateData() {
      this.getArticles()
      this.getArticlesCount()
    },
    getArticles() {
      if (this.articlesCancelToken) {
        this.articlesCancelToken.cancel()
      }
      this.articlesCancelToken = this.axios.CancelToken.source()
      this.loading = true
      let params = Object.assign({}, this.params)
      params.site_key = this.$attrs.site_key
      params.priority = params.priority ? params.priority : null
      this.$log.debug(params.site_key)
      this.reqId = this.axios({
        url: '/v1/articles',
        method: 'get',
        cancelToken: this.articlesCancelToken.token,
        params: params,
      })
        .then((resp) => {
          this.articles = resp.data
          this.$log.debug('articles', params)
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            return
          }
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
        .finally(() => {
          this.loading = false
        })
    },
    getArticlesCount() {
      if (this.countCancelToken) {
        this.countCancelToken.cancel()
      }
      this.countCancelToken = this.axios.CancelToken.source()
      let params = Object.assign({}, this.params)
      params.site_key = this.$attrs.site_key
      params.priority = params.priority ? params.priority : null
      this.axios({
        url: '/v1/articles/count',
        method: 'get',
        cancelToken: this.countCancelToken.token,
        params: params,
      })
        .then((resp) => {
          const count = resp.data.count
          this.totalPage = Math.ceil(count / params.limit)
          this.$log.debug('total', this.totalPage, params)
        })
        .catch((err) => {
          if (!this.axios.isCancel(err)) {
            this.$log.error(err)
          }
        })
    },
    updateArticle(event) {
      for (let a in this.articles) {
        if (this.articles[a].id === event.id) {
          this.$set(this.articles, a, event)
        }
      }
    },
  },
}
</script>
